import { useEffect } from "react";
import { useNavigate } from "react-router";

export const Redirect = (props: { path: string }) => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate(props.path);
  }, [navigate, props.path]);
  return <div>Redirecting...</div>;
};
